import React, { useState, useEffect, useContext } from 'react';
import { toast } from 'react-toastify';
import DefaultCard from '../../../../../../components/default/DefaultCard';
import DefaultToolBar from '../../../../../../components/default/DefaultToolBar';
import ButtonCreate from '../../../../../../components/buttons/ButtonCreate';
import DefaultModal from '../../../../../../components/default/DefaultModal';
import WarehouseQuoteDetailCreate from '../WarehouseQuoteDetailCreate';
import WarehouseQuoteDetailEdit from '../WarehouseQuoteDetailEdit';
import useSweetAlert from '../../../../../../hooks/useSweetAlert';
import useWarehouseQuoteDetailService from '../../../../../../app/services/hooks/useWarehouseQuoteDetailService';
import { WarehouseQuoteDetailDataForm, WarehouseQuoteDetailFilters } from '../../../../../../app/models/WareHouseQuoteDetail';
import { ServiceResponse } from '../../../../../../app/services/shared/interfaces';
import WarehouseQuoteDetailDataTable from '../tables/WareHouseQuoteDetailDataTable';
import { AppContext } from '../../../../../../contexts/AppContext';
import useReactConfirmAlert from '../../../../../../hooks/useReactConfirmAlert';
import WarehouseQuoteDetailShow from '../WarehouseQuoteDetailShow';

interface Props {
    quoteId: number;
    sectorId: number;
    disableUpdate?: boolean;
    reloadQuote?: () => void;
    isFormShow?: boolean;
    refresh?: number;
    onDetailSaved: () => void;
}

const WarehouseQuoteDetailsContainer = ({ 
    quoteId,
    sectorId,
    isFormShow = false,
    disableUpdate = false,
    reloadQuote,
    refresh,
    onDetailSaved 
}: Props) => {

    const {
        getAllWarehouseQuoteDetailsByQuote,
        deleteWarehouseQuoteDetail,
        showWarehouseQuoteDetail,
        fetchingGetWarehouseQuoteDetails
    } = useWarehouseQuoteDetailService();

    const [warehouseQuoteDetails, setWarehouseQuoteDetails] = useState<WarehouseQuoteDetailDataForm[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [filter, setFilter] = useState<WarehouseQuoteDetailFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });
    const [refreshKey, setRefreshKey] = useState(0)
    const [showingCreate, setShowingCreate] = useState(false);
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingShow, setShowingShow] = useState(false);
    const [selectedDetail, setSelectedDetail] = useState<WarehouseQuoteDetailDataForm>();
    
    const [warehouseQuoteDetailIdEdit, setWarehousewarehouseQuoteDetailIdEdit] = useState<number>(-1);
    const [warehouseQuoteDetailIdCreate, setWarehousewarehouseQuoteDetailIdCreate] = useState<number>(-1);
    const [warehouseQuoteDetailIdShow, setWarehousewarehouseQuoteDetailIdShow] = useState<number>(-1);
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const show =  (id: number) => {
        setShowingShow(true);
        setWarehousewarehouseQuoteDetailIdShow(id);

    };

    const showEdit = (id: number) => {
        setShowingEdit(true);
        setWarehousewarehouseQuoteDetailIdEdit(id);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setWarehousewarehouseQuoteDetailIdEdit(-1);
    };

    const hideShow = () => {
        setShowingShow(false);
        setWarehousewarehouseQuoteDetailIdShow(-1);
    };
    useEffect(() => {
        if (quoteId) reloadTable();
    }, [quoteId, filter, refresh]);

    const reloadTable = () => {
        getAllWarehouseQuoteDetailsByQuote(quoteId,filter, {
            onSuccess: (response: ServiceResponse) => {
                setWarehouseQuoteDetails(response.data.warehouse_quote_details);
                setTotalRows(response.data.total_rows);
            }
        });
    };

    // const show = (id: number) => {
    //     showWarehouseQuoteDetail(id, {
    //         onSuccess: (response: ServiceResponse) => {
    //             setSelectedDetail(response.data.warehouse_quote_detail);
    //             setShowingShow(true);
    //         }
    //     });
    // };

    // const edit = (id: number) => {
    //     const detail = warehouseQuoteDetails.find(d => d.id === id);
    //     if (detail) {
    //         setSelectedDetail(detail);
    //         setShowingEdit(true);
    //     }
    // };

    // const destroy = (id: number) => {
    //     useSweetAlert().requestConfirmation({
    //         title: '¿Está seguro?',
    //         text: `Está a punto de eliminar el detalle de cotización #${id}`,
    //         confirmButtonText: 'Sí, eliminar',
    //         cancelButtonText: 'Cancelar',
    //         onConfirm: () => {
    //             deleteWarehouseQuoteDetail(id, {
    //                 onSuccess: () => {
    //                     toast.success('Detalle eliminado con éxito');
    //                     reloadTable();
    //                     reloadQuote?.();
    //                 },
    //                 onError: (response: ServiceResponse) => {
    //                     toast.error(response.message);
    //                 }
    //             });
    //         }
    //     });
    // };


    const destroy = (id: number) => {
        const message = `Está a punto de eliminar la tarifa #${id}`;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: message,
            buttons: {
                confirmButton: {
                    label: 'Sí, eliminar',
                    onClick: () => {
                        if (showLoading)
                            showLoading('loading', 'Eliminando tarifa...');

                        deleteWarehouseQuoteDetail(id, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'Cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'La tarifa no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    return (
        <>
            <DefaultCard>

                <div className="h3 mt-0 mb-4 card-title">Posiciones</div> 
                <div className="row">
                    <div className="col-12">
                        {!isFormShow && (

                        <DefaultToolBar left={<ButtonCreate callbackCreate={() => setShowingCreate(true)} />} />
                        )}
                    
                    </div>
                    <div className="col-12">
                        <WarehouseQuoteDetailDataTable
                            warehouseQuoteDetails={warehouseQuoteDetails}
                            totalRows={totalRows}
                            loading={fetchingGetWarehouseQuoteDetails}
                            show={show}
                            edit={showEdit}
                            destroy={destroy}
                            filter={filter}
                            isShow={isFormShow}
                            setFilter={setFilter}
                        />
                    </div>
                </div>
            </DefaultCard>

            <DefaultModal
                show={showingCreate}
                handleClose={() => setShowingCreate(false)}
                title="Crear Detalle Oferta WareHouse"
                showFooter={false}
            >
                <WarehouseQuoteDetailCreate
                    quoteId={quoteId}
                    sectorId={sectorId}
                    onSaved={() => {
                        reloadTable();
                        setShowingCreate(false);
                         onDetailSaved();  
                    }}
                    onCancel={() => setShowingCreate(false)}
                />
            </DefaultModal>
       {showingEdit ?(
            <DefaultModal
                show={showingEdit}
                handleClose={() => setShowingEdit(false)}
                title="Editar Detalle Almacén"
                showFooter={false}
            >
                <WarehouseQuoteDetailEdit
                    warehouseQuoteDetialId={warehouseQuoteDetailIdEdit}
                    quoteId={quoteId}
                    onSaved={() => {
                        reloadTable();
                        setShowingEdit(false);
                    }}
                    onCancel={() => setShowingEdit(false)}
                />
            </DefaultModal>
            ) : null}

        {showingShow ? (
            <DefaultModal
                show={showingShow}
                handleClose={hideShow}
                title="Ver información posicion de la cotizacion"

            >
                <WarehouseQuoteDetailShow 
                warehouseDetailId={warehouseQuoteDetailIdShow}
                onCancel={hideShow}
                // onError={hideShow}
                />
            </DefaultModal>
            ) : null}

        </>
    );
};

export default WarehouseQuoteDetailsContainer;
